import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { PaymentForm } from '../components/Payment/PaymentForm';
import { PaystackScript } from '../components/Payment/PaystackScript';
import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export const InnerCircle = () => {
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'success' | 'form'>('pending');
  const [reference, setReference] = useState('');
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setPaymentStatus('form');
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    fetch('https://formspree.io/f/xkgqkqqd', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        setPaymentStatus('success');
        // Redirect to WhatsApp group
        window.location.href = 'https://chat.whatsapp.com/HqLapNaswMWGUkOjGdHd37';
      } else {
        throw new Error('Form submission failed');
      }
    }).catch(error => {
      console.error('Error:', error);
      // Handle error state
    });
  };
  if (paymentStatus === 'success') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3400" data-mp="1tr8zn4wzrie5">
        <div className="container mx-auto px-4 py-16" data-id="element-3401" data-mp="w6w4ac2ljtq1">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3402" data-mp="114xoj0brdz33">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3403" data-mp="115fqmdl3r7ix">
              <Check size={40} className="text-gray-700" data-id="element-3404" data-mp="161xsn5p1srrk" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3405" data-mp="1avis726ahtsv">
              Welcome to The Networking Salon Inner Circle!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3406" data-mp="ie6io8qzcqtg">
              Thank you for joining our community. Your registration was
              successful.
            </p>
            <p className="text-gray-600 mb-12" data-id="element-3407" data-mp="abnpid8kt2me">
              We're redirecting you to our WhatsApp community...
            </p>
          </div>
        </div>
      </div>;
  }
  if (paymentStatus === 'form') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3408" data-mp="f4gvf4fs6h02">
        <div className="container mx-auto px-4 py-16" data-id="element-3409" data-mp="f5rx8ypo1eoj">
          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-3410" data-mp="3nk0l5th8thad">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3411" data-mp="3nkip7ca5czsu">
              <Check size={40} className="text-gray-700" data-id="element-3412" data-mp="3injyz4tltczx" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3413" data-mp="1edfswbepljl">
              Payment Successful!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3414" data-mp="1cs7h275keof9">
              Please complete your registration to join The Networking Salon
              Inner Circle.
            </p>
            <p className="text-gray-600 mb-8" data-id="element-3415" data-mp="17sur3djed18g">
              Reference ID: <span className="font-medium" data-id="element-3416" data-mp="1fblydtik7rho">{reference}</span>
            </p>
          </div>
          <div className="max-w-2xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3417" data-mp="1kc07zfzt79ht">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3418" data-mp="16ch10qiqi473">
              Complete Your Registration
            </h2>
            <form onSubmit={handleFormSubmit} className="space-y-6" data-id="element-3419" data-mp="1ae2loy1ifmru">
              <input type="hidden" name="payment_reference" value={reference} data-id="element-3420" data-mp="1y2v8o505mkab" />
              <div data-id="element-3421" data-mp="231yh7zfcf8n1">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3422" data-mp="232homm7daemt">
                  Full Name <span className="text-gray-500" data-id="element-3423" data-mp="1pbcuu0qokgke">(required)</span>
                </label>
                <input type="text" name="name" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3424" data-mp="1tc6j4v81bxdt" />
              </div>
              <div data-id="element-3425" data-mp="2h17lc0q9ycan">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3426" data-mp="2h0prtbuzyc6f">
                  Email <span className="text-gray-500" data-id="element-3427" data-mp="2ltivdweqbegx">(required)</span>
                </label>
                <input type="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3428" data-mp="y5fpazfb5j25" />
              </div>
              <div data-id="element-3429" data-mp="t7nvu0z0lovu">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3430" data-mp="o5ygwa8o8r2h">
                  Phone Number <span className="text-gray-500" data-id="element-3431" data-mp="k4mq41e29zsp">(required)</span>
                </label>
                <input type="tel" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3432" data-mp="k6zi77dj9qjh" />
              </div>
              <div data-id="element-3433" data-mp="1bvj2l0w7m2fg">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3434" data-mp="1bx3zuy9wrzh0">
                  What do you do?{' '}
                  <span className="text-gray-500" data-id="element-3435" data-mp="1739hpz9ybsk1">(required)</span>
                </label>
                <textarea name="occupation" required rows={3} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3436" data-mp="132za6i6igu32" />
              </div>
              <div data-id="element-3437" data-mp="1uux17w4vw1ca">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3438" data-mp="1uueto3cru0p2">
                  What are you looking to gain from the Inner Circle?{' '}
                  <span className="text-gray-500" data-id="element-3439" data-mp="3djhrv3m9kq1j">(required)</span>
                </label>
                <textarea name="goals" required rows={3} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3440" data-mp="3igrn4zwc3vxa" />
              </div>
              <div data-id="element-3441" data-mp="3rhphsrkvur37">
                <Button type="submit" className="w-full" data-id="element-3442" data-mp="3ri9049eg3hhr">
                  Complete Registration
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white" data-id="element-3443" data-mp="58oldibu28ka">
      <PaystackScript data-id="element-3444" data-mp="57vdge151d0k" />
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3445" data-mp="a1r5kzuq05nt">
        <div className="absolute inset-0 z-0" data-id="element-3446" data-mp="e21mv8nyqihz">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3447" data-mp="e1ruxfjcy19n" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3448" data-mp="o1ip1g40ae97"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3449" data-mp="2k2u8nd4ro49n">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3450" data-mp="2k19azen5o57k">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3451" data-mp="2f5tzgtcmeleb">
              INNER CIRCLE MEMBERSHIP
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3452" data-mp="2p26srq496x8j">
              Join The Inner Circle
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3453" data-mp="32sinzxw4xc3w">
              Connect with ambitious professionals, build meaningful
              relationships, and unlock new opportunities.
            </p>
            <Button className="text-lg px-8 py-4" onClick={() => {
            setShowPaymentForm(true);
            setTimeout(() => {
              const element = document.getElementById('payment-form');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 100);
          }} data-id="element-3454" data-mp="3crrg0l7fwgnm">
              Join Today for ₦20,000 (Founder's Offer)
            </Button>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-3455" data-mp="3u3g9bhasze07">
        <div className="container mx-auto px-4" data-id="element-3456" data-mp="3fdh8t7vrzqhk">
          <div className="max-w-3xl mx-auto" data-id="element-3457" data-mp="3fampjjoi0bpq">
            <div className="border-2 border-gray-300 rounded-lg p-8 mb-12" data-id="element-3458" data-mp="3kb0ma5knfz8g">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3459" data-mp="36cariwlaybn9">
                🌍 What the Inner Circle Is About
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3460" data-mp="3bcp14j2jxtne">
                The Inner Circle is the core community of The Networking Salon —
                a space for intentional people who want to grow, collaborate,
                and connect with purpose.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-3461" data-mp="um8f98p2e1p7">
                It's where ideas are refined, opportunities are shared, and
                relationships evolve into partnerships. Members of the Inner
                Circle gain access to curated experiences that help them learn,
                lead, and thrive within a trusted network of business leaders,
                coaches, and creators.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-3462" data-mp="39qhqjamhdwm5">
                This is a community for action-takers — those who believe in
                learning through collaboration, growing through mentorship, and
                building through shared value.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3463" data-mp="2vri2o56sllr1">
                🔑 How to Gain Access
              </h3>
              <div className="mb-6" data-id="element-3464" data-mp="2qtzskbh1h0hg">
                <p className="font-bold text-gray-800" data-id="element-3465" data-mp="2qv14sj9sjt0r">
                  Through Direct Membership Enrollment
                </p>
                <p className="text-gray-700" data-id="element-3466" data-mp="p23fuyj4xkl3">
                  Join by registering directly as an Inner Circle Member.
                </p>
                <div className="bg-gray-100 p-4 rounded-lg my-4 text-center" data-id="element-3467" data-mp="k309narf58bj">
                  <p className="font-bold text-gray-800" data-id="element-3468" data-mp="rkyg16eb03aj">
                    Membership Fee: ₦50,000 per year
                  </p>
                  <p className="text-gray-700 italic" data-id="element-3469" data-mp="wj9rflk8yluv">
                    (Currently discounted to ₦20,000)
                  </p>
                </div>
                <p className="text-gray-700 mb-2" data-id="element-3470" data-mp="16bfj0u6l719j">
                  Once enrolled, you'll gain access to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4" data-id="element-3471" data-mp="8ofbkueg33kb">
                  <li data-id="element-3472" data-mp="dn9v5yk8kw5h">Curated masterclasses and peer masterminds</li>
                  <li data-id="element-3473" data-mp="ill509aj76np">Mentorship and strategy sessions</li>
                  <li data-id="element-3474" data-mp="ik08ie4npdn7">Growth tools, templates, and learning resources</li>
                  <li data-id="element-3475" data-mp="nlfse2v3le40">
                    Networking with business leaders, coaches, and fellow
                    builders
                  </li>
                  <li data-id="element-3476" data-mp="1u2t5wklyy4n4">
                    The private digital community — your home for collaboration
                    and opportunity
                  </li>
                </ul>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3477" data-mp="d3kp2ea5k5fm">
                ✳️ Who the Inner Circle Is For
              </h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-3478" data-mp="lxfnz4kokzmt">
                <li data-id="element-3479" data-mp="qwipwg5d6pqk">
                  Entrepreneurs, professionals, and creators ready to grow
                  intentionally
                </li>
                <li data-id="element-3480" data-mp="3qdi8906pv2ry">
                  Those seeking meaningful collaboration rather than
                  surface-level networking
                </li>
                <li data-id="element-3481" data-mp="36oiie3tdtdp">
                  Individuals who value mentorship, shared learning, and mutual
                  support
                </li>
                <li data-id="element-3482" data-mp="87lx6gpm85ag">
                  People who want to connect with a network of leaders and
                  builders across industries
                </li>
              </ul>
              <p className="text-gray-700 font-medium text-center mt-8" data-id="element-3483" data-mp="1jk68xqqzl8b3">
                The Inner Circle is where energy turns into execution. It's
                where you stop networking for attention and start connecting for
                impact.
              </p>
              <div className="text-center mt-6" data-id="element-3484" data-mp="2ud6x9vq971kz">
                <p className="text-gray-800 font-bold" data-id="element-3485" data-mp="2ubvyybfkum19">
                  Join the Inner Circle — and step into a community that helps
                  you rise, build, and belong.
                </p>
              </div>
            </div>
            {showPaymentForm && <div id="payment-form" className="border-2 border-gray-300 rounded-lg p-8" data-id="element-3486" data-mp="2gdo203ijjkq3">
                <PaymentForm onSuccess={handleSuccess} data-id="element-3487" data-mp="2beb9b24znjfl" />
              </div>}
          </div>
        </div>
      </section>
    </div>;
};